module.exports = __webpack_public_path__ + "img/tick-circle.56e25a63.svg";